@if (data) {
<div class="survey-welcome-screen" [style.background-color]="data.backgroundColor" [style.display]="'flex'"
  [style.flex-direction]="'column'" [style.justify-content]="data.verticalAlignment"
  [style.align-items]="data.horizontalAlignment">
  <div class="survey-welcome-screen-content" [style.display]="'flex'" [style.flex-direction]="'column'"
    [style.align-items]="data.horizontalAlignment" [style.text-align]="data.textAlign"
    [style.background-color]="data.backgroundColor">
    @if (data.logoUrl) {
    <img class="survey-welcome-screen-content-logo" [src]="data.logoUrl" alt="Logo"
      [style.width]="data.logoSizePx + 'px'" [style.height]="'auto'" [style.object-fit]="'contain'" />
    }
    <h3 class="survey-welcome-screen-content-title m-0 p-0" [style.color]="data.titleColor"
      [style.font-size]="data.titleFontSize" [style.font-family]="data.titleFontFamily"
      [style.font-weight]="data.titleFontWeight">
      {{ data.title }}
    </h3>
    <p class="survey-welcome-screen-content-description m-0 p-0" [style.color]="data.descriptionColor"
      [style.font-size]="data.descriptionFontSize" [style.font-family]="data.descriptionFontFamily"
      [style.font-weight]="data.descriptionFontWeight">
      {{ data.description }}
    </p>
    <button type="button" class="survey-welcome-screen-content-start" [style.background-color]="data.buttonBgColor"
      [style.color]="data.buttonColor" [style.font-size]="data.buttonFontSize + 'px'"
      [style.font-family]="data.buttonFontFamily" [style.font-weight]="data.buttonFontWeight" [style.cursor]="'pointer'"
      (click)="onStartClick()">
      {{ data.buttonName }}
    </button>
  </div>
</div>
}